import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const avialablePluckingDeductions = this.props.avialablePluckingDeductions;
        const totalCollections = this.props.totalCollections;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Division Summary Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division == 0 ? "All" : searchData.division}</div>
                    <div className="col"><b>Field: </b> {searchData.field == 0 ? "All" : searchData.field}</div>
                    <div className="col"><b>Search Date: </b> {searchData.searchDate}</div>
                    <div className="col"><b>Category: </b> {searchData.categoryID == 0 ? "All" : searchData.categoryID == 1 ? "Outsource" : "Revenue"}</div>
                </div>
                <div>
                    {/* FIX: this summary row must live inside its own <Table>/<TableBody> —
                        a bare <TableRow> directly inside a <div> is invalid HTML and gets
                        hoisted out of place by the browser, breaking the layout. */}
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan="2" style={{ fontWeight: "bold" }}>Yield Ratio</TableCell>
                                {/* FIX: this gap must span Category (1) + the 4 fixed plucking
                                    columns (Gross/Applied/RoundDown/Checkroll) + the dynamic
                                    deduction columns, i.e. 5 + length, not 1 + length. The old
                                    value under-counted by 4, which shifted every following cell
                                    out of alignment with the table below. */}
                                <TableCell colSpan={5 + avialablePluckingDeductions.length}></TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Factory / Checkroll</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                    {(() => {
                                        var factoryNet = parseFloat(totalCollections.factoryNetWeight);
                                        var checkroll = parseFloat(totalCollections.pluckingCheckrollWeight);
                                        if (!factoryNet || !checkroll) return "-";
                                        var val = ((factoryNet - checkroll) / factoryNet) * 100;
                                        return isFinite(val) ? val.toFixed(0) + "%" : "-";
                                    })()}
                                </TableCell>
                                <TableCell colSpan="3"></TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Field / Factory</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                    {(() => {
                                        var fieldNet = parseFloat(totalCollections.fieldNetWeight);
                                        var factoryNet = parseFloat(totalCollections.factoryNetWeight);
                                        if (!fieldNet || !factoryNet) return "-";
                                        var val = ((fieldNet - factoryNet) / fieldNet) * 100;
                                        return isFinite(val) ? val.toFixed(0) + "%" : "-";
                                    })()}
                                </TableCell>
                                <TableCell colSpan="2"></TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Field / Checkroll</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                    {(() => {
                                        var fieldNet = parseFloat(totalCollections.fieldNetWeight);
                                        var checkroll = parseFloat(totalCollections.pluckingCheckrollWeight);
                                        if (!fieldNet || !checkroll) return "-";
                                        var val = ((fieldNet - checkroll) / fieldNet) * 100;
                                        return isFinite(val) ? val.toFixed(0) + "%" : "-";
                                    })()}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Field</TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Category</TableCell>
                                <TableCell
                                    align="center"
                                    colSpan={4 + avialablePluckingDeductions.length}
                                    style={{ background: "lightblue", fontWeight: "bold" }}
                                >
                                    Plucker collection
                                </TableCell>
                                <TableCell align="center" colSpan="5" style={{ background: "lightgreen", fontWeight: "bold" }}>
                                    Field collection
                                </TableCell>
                                <TableCell align="center" colSpan="7" style={{ background: "lightyellow", fontWeight: "bold" }}>
                                    Factory collection
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Checkroll Weight</TableCell>

                                {avialablePluckingDeductions.map((x, index) => (
                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }} key={index}>
                                        {x}
                                    </TableCell>
                                ))}

                                <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Net Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>No Of Bags</TableCell>

                                <TableCell align="center" style={{ fontWeight: "bold" }}>Receiving Factory</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Original Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Net Weight</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>No Of Bags</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                var rowSpanCounts = {};
                                reportData.forEach((row) => {
                                    if (row.isBold) return;
                                    var key = `${row.collectionPointID}_${row.fieldID}`;
                                    rowSpanCounts[key] = (rowSpanCounts[key] || 0) + 1;
                                });

                                var renderedGroups = new Set();

                                return reportData.map((row, idx) => {
                                    var groupKey = row.isBold ? null : `${row.collectionPointID}_${row.fieldID}`;
                                    var isFirstOfGroup = groupKey ? !renderedGroups.has(groupKey) : true;
                                    if (groupKey) renderedGroups.add(groupKey);
                                    var span = groupKey ? rowSpanCounts[groupKey] : 1;
                                    var boldStyle = { fontWeight: row.isBold == undefined ? null : "bold" };

                                    return (
                                        <TableRow key={idx}>
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                                    {row.collectionPointName == undefined ? "-" : row.collectionPointName}
                                                </TableCell>
                                            )}
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                                    {row.fieldName == undefined ? "-" : row.fieldName}
                                                </TableCell>
                                            )}
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                                    {row.isBold ? "-" : row.category === true ? "Outsource" : row.category === false ? "Revenue" : "-"}
                                                </TableCell>
                                            )}

                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                                    {row.pluckingGrossWeight == undefined ? "-" : parseFloat(row.pluckingGrossWeight).toFixed(2)}
                                                </TableCell>
                                            )}
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                                    {row.pluckingAppliedDeduction == undefined ? "-" : parseFloat(row.pluckingAppliedDeduction).toFixed(2)}
                                                </TableCell>
                                            )}
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                                    {row.pluckingRoundDownDeduction == undefined ? "-" : parseFloat(row.pluckingRoundDownDeduction).toFixed(2)}
                                                </TableCell>
                                            )}
                                            {isFirstOfGroup && (
                                                <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                                    {row.pluckingCheckrollWeight == undefined ? "-" : parseFloat(row.pluckingCheckrollWeight).toFixed(2)}
                                                </TableCell>
                                            )}

                                            {isFirstOfGroup && avialablePluckingDeductions.map((d, i) => (
                                                <TableCell rowSpan={span} key={i} align="right" style={boldStyle}>
                                                    {row[d] == undefined ? "-" : parseFloat(row[d]).toFixed(2)}
                                                </TableCell>
                                            ))}

                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.fieldGrossWeight == undefined ? "-" : parseFloat(row.fieldGrossWeight).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.fieldAppliedDeduction == undefined ? "-" : parseFloat(row.fieldAppliedDeduction).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.fieldRoundDownDeduction == undefined ? "-" : parseFloat(row.fieldRoundDownDeduction).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.fieldNetWeight == undefined ? "-" : row.isBold ? parseInt(row.fieldNetWeight) : parseFloat(row.fieldNetWeight).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.fieldNoOfBags == undefined ? "-" : row.fieldNoOfBags}
                                            </TableCell>

                                            <TableCell component="th" scope="row" style={boldStyle}>
                                                {row.recievingFactory == undefined ? "-" : row.recievingFactory}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryOriginalWeight == undefined ? "-" : parseFloat(row.factoryOriginalWeight).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryRoundDownDeduction == undefined ? "-" : parseFloat(row.factoryRoundDownDeduction).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryGrossWeight == undefined ? "-" : parseFloat(row.factoryGrossWeight).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryAppliedDeduction == undefined ? "-" : parseFloat(row.factoryAppliedDeduction).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryNetWeight == undefined ? "-" : row.isBold ? parseInt(row.factoryNetWeight) : parseFloat(row.factoryNetWeight).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                                {row.factoryNoOfBags == undefined ? "-" : row.factoryNoOfBags}
                                            </TableCell>
                                        </TableRow>
                                    );
                                });
                            })()}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan="3" align="center" style={{ fontWeight: "bold" }}>Total</TableCell>

                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.pluckingGrossWeight).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.pluckingAppliedDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.pluckingRoundDownDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.pluckingCheckrollWeight).toFixed(2)}
                                </TableCell>

                                {avialablePluckingDeductions.map((x, i) => (
                                    <TableCell key={i} component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                        {parseFloat(totalCollections[x] || 0).toFixed(2)}
                                    </TableCell>
                                ))}

                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.fieldGrossWeight).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.fieldAppliedDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.fieldRoundDownDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseInt(totalCollections.fieldNetWeight)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.fieldNoOfBags}
                                </TableCell>

                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.factoryOriginalWeight).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.factoryRoundDownDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.factoryGrossWeight).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseFloat(totalCollections.factoryAppliedDeduction).toFixed(2)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {parseInt(totalCollections.factoryNetWeight)}
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.factoryNoOfBags}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell rowSpan="2" colSpan="3" align="center" style={{ fontWeight: "bold" }}>
                                    Gain percentages
                                </TableCell>

                                <TableCell></TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.pluckingGrossWeight
                                        ? ((totalCollections.pluckingAppliedDeduction / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.pluckingGrossWeight
                                        ? ((totalCollections.pluckingRoundDownDeduction / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.pluckingGrossWeight
                                        ? ((totalCollections.pluckingCheckrollWeight / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>

                                {avialablePluckingDeductions.map((x, i) => (
                                    <TableCell key={i}></TableCell>
                                ))}

                                <TableCell></TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.fieldGrossWeight
                                        ? ((totalCollections.fieldAppliedDeduction / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.fieldGrossWeight
                                        ? ((totalCollections.fieldRoundDownDeduction / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.fieldGrossWeight
                                        ? ((totalCollections.fieldNetWeight / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell></TableCell>

                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.factoryOriginalWeight
                                        ? ((totalCollections.factoryRoundDownDeduction / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.factoryOriginalWeight
                                        ? ((totalCollections.factoryAppliedDeduction / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.factoryOriginalWeight
                                        ? ((totalCollections.factoryNetWeight / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={4 + avialablePluckingDeductions.length}></TableCell>

                                <TableCell colSpan="3" align="center" style={{ fontWeight: "bold" }}>
                                    Checkroll to Field loss (O. Wt.)
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.pluckingGrossWeight
                                        ? ((totalCollections.pluckingGrossWeight - totalCollections.fieldGrossWeight) / totalCollections.pluckingGrossWeight * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell></TableCell>

                                <TableCell colSpan="5" align="center" style={{ fontWeight: "bold" }}>
                                    Field to Factory loss (O. Wt.)
                                </TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                    {totalCollections.fieldGrossWeight
                                        ? ((totalCollections.fieldGrossWeight - totalCollections.factoryGrossWeight) / totalCollections.fieldGrossWeight * 100).toFixed(0) + "%"
                                        : "-"}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </div>
            </div>
        );
    }
}